import { motion } from 'framer-motion';
import { useParams } from 'react-router';
import { useAppSelector } from '~/hooks/useAppSelector';
import { Center, Column, Text } from '~/commonComponents';
import { UserProfession } from '~/enums/UserProfession';
import {
  EmptyFilteredFavorites,
  EmptyFilteredRecent,
  EmptyFilteredRecommendedPros,
} from '~/images/professionalHub';
import { Colors } from '~/themes/colors';
import { TABS } from '../utils';

export const EmptyFilteredList = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5 }}
    style={{
      maxWidth: '827px',
      display: 'flex',
      flexDirection: 'column',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 40,
      marginBottom: 80,
    }}
  >
    <Description />
  </motion.div>
);

const Description = () => {
  const filter = useAppSelector((state) => state.user.professionalHubFilter);
  const params = useParams();
  const { type } = params;
  const profession = UserProfession.getName(filter);

  let title = '';
  let description = '';
  let Icon = null;

  switch (type) {
    case TABS.FAVORITES_LIST:
      Icon = EmptyFilteredFavorites;
      title = 'No professionals added yet!';
      // eslint-disable-next-line max-len
      description = `You have not added any ${profession} to your Favorites List yet. Add one to get started!`;
      break;
    case TABS.RECENT_PROFESSIONALS:
      Icon = EmptyFilteredRecent;
      title = 'No professionals yet!';
      // eslint-disable-next-line max-len
      description = `Your office has not recently worked with any ${profession} on GoTu yet. Connect with one to get started!`;
      break;
    case TABS.RECOMMENDED_PROS:
      Icon = EmptyFilteredRecommendedPros;
      title = `No new ${profession}s at this time!`;
      // eslint-disable-next-line max-len
      description = `We are actively searching for any ${profession} who meet the “New to You” criteria in your area. Please check back soon to see the results!`;
      break;
    default:
  }

  return (
    <Center width={400} gap={32}>
      {Icon && <Icon />}
      <Column gap={8}>
        <Text color={Colors.neutral_500} bold fontSize={22} textAlign="center">
          {title}
        </Text>
        <Text color={Colors.neutral_500} textAlign="center">
          {description}
        </Text>
      </Column>
    </Center>
  );
};
